import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import store from './store';
import { createGlobalStyle } from 'styled-components';
import { Normalize } from 'styled-normalize'
import App from './App';

const GlobalStyle = createGlobalStyle`

  * {
    box-sizing: border-box;
  }

  body {
    margin: 0;
    padding: 0;
    font-family: 'Playfair Display', serif;
    font-size: 16px;
    font-weight: 400;
  }

  #root {
    width: 100vw;
    height: 100vh;
  }

`;

ReactDOM.render(
  <Provider store={store}>
    <Normalize />
    <GlobalStyle />
    <App />
  </Provider>,
  document.getElementById('root')
);
